import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    Box,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TableContainer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface TelematicCheckDialogProps {
    open: boolean;
    onClose: () => void;
    data: any;
}

const TelematicCheckDialog: React.FC<TelematicCheckDialogProps> = ({ open, onClose, data }) => {
    if (!data) return null;

    const formatValue = (key: string, value: any) => {
        if (value === null || value === undefined || value === '') return 'N/A';
        if (typeof value === 'boolean') return value ? 'YES' : 'NO';
        if (key.endsWith('TS') || key.toLowerCase().includes('time') || key.toLowerCase().includes('date')) {
            const num = Number(value);
            if (!isNaN(num) && num > 1000000000) { // Check for Unix timestamp in seconds
                const d = new Date(num * 1000);
                const pad = (n: number) => n.toString().padStart(2, '0');
                return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            }
        }
        return String(value);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 1 } }}>
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 3,
                pb: 2
            }}>
                <Typography variant="h5" component="div" sx={{ color: '#222', fontWeight: 500 }}>
                    EOLT Details
                </Typography>
                <IconButton onClick={onClose} aria-label="close" sx={{ color: '#555' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: '0 24px 24px 24px' }}>
                <TableContainer component={Box} sx={{ border: '1px solid #e0e0e0', borderRadius: 0 }}>
                    <Table size="small">
                        <TableBody>
                            {Object.entries(data).filter(([key]) => key !== '__typename').map(([key, value]) => {
                                const displayKey = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase()).trim();
                                const displayValue = formatValue(key, value);
                                return (
                                    <TableRow key={key}>
                                        <TableCell sx={{
                                            width: '40%',
                                            borderRight: '1px solid #e0e0e0',
                                            borderBottom: '1px solid #e0e0e0',
                                            color: '#444',
                                            p: '16px 24px',
                                            fontSize: '14px',
                                            backgroundColor: '#fff'
                                        }}>
                                            {displayKey}
                                        </TableCell>
                                        <TableCell sx={{
                                            borderBottom: '1px solid #e0e0e0',
                                            color: '#222',
                                            p: '16px 24px',
                                            fontSize: '14px',
                                            backgroundColor: displayValue === 'YES' ? '#5ab384' : 'transparent'
                                        }}>
                                            {displayValue}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
};

export default TelematicCheckDialog;
